<template>
  <div class="dynamic-content">
    <div class="new-title">{{ title }}</div>
    <div class="new-date">{{ createTime }}</div>
    <div class="paragraph" v-html="content" />
    <div class="recent-news">
      <div class="top">
        <img src="@/assets/Mobile/images/about/about-icon.png" alt="">
        <span>最新动态</span>
      </div>
      <div v-for="(item, index) in newsList" :key="index" @click="loadPage(item.infoNo)">
        <div class="title">{{ item.title }}</div>
        <div class="date">{{ item.createTime }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import metaInfo from '@/common/util/metaInfo'
import { getOfficialWebsiteInfomationInfo, getOfficialWebsiteInfomationList } from '@/apis/index'
export default {
  metaInfo: metaInfo.Dynamic,
  name: 'DynamicDetail',
  data() {
    return {
      title: '',
      createTime: '',
      content: '',
      newsList: []
    }
  },
  watch: {
    '$route'(to, from) {
      this.getInfoDeatail()
    }
  },
  mounted() {
    this.getInfoDeatail()
    this.getHistory()
  },
  methods: {
    getInfoDeatail() {
      const id = this.$route.params.id
      getOfficialWebsiteInfomationInfo(id).then(res => {
        if (res) {
          this.title = res.title
          this.createTime = res.createTime
          this.content = res.content
        }
      }).catch(err => {
        this.$message.error(err)
      })
    },
    getHistory() {
      const params = {
        pageNum: 1,
        pageSize: 6
      }
      getOfficialWebsiteInfomationList(params).then(res => {
        this.newsList = res.rows
      }).catch(err => {
        this.$message.error(err)
      })
    },
    loadPage(id) {
      this.$router.push({ path: '/m/dynamicDetail/' + id })
    }
  }
}
</script>
<style lang="less" scoped>
.dynamic-content {
  margin-top: 50px;
  padding: 20px 16px;
  .new-title {
    font-size: 20px;
    font-weight: 500;
    color: #222222;
    line-height: 28px;
    text-align: left;
  }
  .new-date {
    margin-top: 10px;
    font-size: 12px;
    font-weight: 400;
    color: #8B8FA1;
    line-height: 17px;
    text-align: left;
  }
  .paragraph {
    margin-top: 17px;
    text-align: left;
    /deep/ img {
      max-width: 100% !important;
    }
  }
  .recent-news {
    text-align: left;
    .top {
      margin: 33px 0 30px 0;
      img {
        width: 24px;
        height: 24px;
        vertical-align: middle;
      }
      span {
        margin-left: 14px;
        font-size: 20px;
        font-weight: 500;
        color: #222222;
        line-height: 28px;
        vertical-align: middle;
      }
    }
    .title {
      font-size: 14px;
      font-weight: 500;
      color: #222222;
      line-height: 20px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .date {
      margin-top: 10px;
      margin-bottom: 21px;
      font-size: 12px;
      font-weight: 400;
      color: #8B8FA1;
      line-height: 17px;
    }
  }
}
</style>
